export const mediaSourceDimensions = {};
const DEFAULT_BACKGROUND_IMAGE_URL = "https://specterr.b-cdn.net/bg-default.jpg";
mediaSourceDimensions[DEFAULT_BACKGROUND_IMAGE_URL] = { width: 2304, height: 1296 };